import { useEffect } from "react";
import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { usePRD5030_R01Store } from "./Store_PRD5030_R01";
import { Content_PRD5030_R01 } from "./Content_PRD5030_R01";
import { SearchSection_PRD5030_R01 } from "./SearchSection_PRD5030_R01";
import { Chart_PRD5030_R01 } from "./Chart_PRD5030_R01";
import { Table_PRD5030_R01 } from "./Table_PRD5030_R01";

/**
 * PRD5030_R01 시간가동율 조회 컨테이너
 * 상단: 콤보차트 / 하단: 월별 피벗 테이블
 */
export const Container_PRD5030_R01 = () => {
	const { PRD5030_R01List, initData } = usePRD5030_R01Store();
	const { setMessage } = useUiuxStore();
	const { workPlaceList, fetchWorkPlaceCdCode } = useCommonCodeStore();

	// 공정(workPlaceList)은 공통코드 일괄 로드 묶음에 없으므로, 비어 있으면 별도 호출
	useEffect(() => {
		if (workPlaceList.length === 0) {
			fetchWorkPlaceCdCode();
		}
	}, [workPlaceList.length, fetchWorkPlaceCdCode]);

	const { fetchData } = Content_PRD5030_R01({ setMessage });

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onSaveClick={undefined}
				onDeleteClick={() => {}}
				onInitClick={initData}
				onExcelClick={() => {}}
				onPrintClick={() => {}}
			/>

			<SearchSection_PRD5030_R01 />

			<div className="flex-1 flex flex-col min-h-0 px-[12px] py-[5px] gap-[10px] overflow-auto">
				<div className="w-full shrink-0">
					<Chart_PRD5030_R01 data={PRD5030_R01List} />
				</div>
				<div className="w-full shrink-0">
					<Table_PRD5030_R01 data={PRD5030_R01List} />
				</div>
			</div>

			<Message />
		</div>
	);
};

export default Container_PRD5030_R01;
